/**
 * Compass product branding — one place for the product's own name and
 * tagline, so they're not scattered as literal strings across every
 * screen. Intentionally minimal: Compass is one product that different
 * organizations use, not (yet) a themeable/white-label system. The
 * organization currently using it (e.g. "Blackhawk Area Council") is
 * separate, legitimate data — it stays wherever it already lives
 * (currently plain text in SignIn.tsx/Layout.tsx, not a configurable
 * setting yet) and is deliberately NOT part of this file.
 */
export const PRODUCT_NAME = 'Compass';
export const PRODUCT_TAGLINE = 'From Data to Decisions to Action';
